import { render, staticRenderFns } from "./jingjiakaishiZhengBao.vue?vue&type=template&id=0218ab83&scoped=true"
import script from "./jingjiakaishiZhengBao.vue?vue&type=script&lang=js"
export * from "./jingjiakaishiZhengBao.vue?vue&type=script&lang=js"
import style0 from "./jingjiakaishiZhengBao.vue?vue&type=style&index=0&id=0218ab83&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218ab83",
  null
  
)

export default component.exports